import type { Role as RoleModel } from '@/adapters/catalogv1.g';

export function extractRole(model: RoleModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.role_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogRole = ReturnType<typeof extractRole>;
